import React, {Component} from 'react';
import {connect} from 'react-redux'
import bindAll from 'lodash.bindall';
import DongtaiDetailComponent from '../components/classactivity/dongtai/dongtai.jsx';
import {closeDongtaiDetailModal} from "../redux/actions/modelsActive";
import {deleteDongtaiRequest, getDongtaiInfoRequest, sendCommentRequest,dianzanRequest} from "../service/activity";
import {FILE_URL} from "../util/constants";
import {Base64} from 'js-base64';
import defaultImg from "../img/bee.png";
import errorPhoto from "../img/ic_photo_error.png";
import Prompt from "../components/prompt/prompt";
import PubSub from "pubsub-js";


class DongtaiDetailContainer extends React.Component {

    constructor(props) {
        super(props)
        bindAll(this, [
            'getDongtaiInfo',
            'handleImageErrored',
            'handleImageErrored2',
            'handleImageErrored3',
            'deleteDongtai',
            'delete',
            'sendComment',
            'inputChange',
            'dianzanMethod',
            'closeDongtaiDetailModal'
        ]);
        this.state = {
            dongtaiInfo: {},
            photoList: [],
            huodong_suyang: [],
            showPrompt: false,
            huifu_list: [],
            inputValue: '',
            dianzannum:'',
            dianzan_status:''
        }

    }


    componentDidMount() {
        this.getDongtaiInfo();
    }

    closeDongtaiDetailModal(){
        PubSub.publish('closeDongtaiDetailModal', '');
        this.props.closeDongtaiDetailModal();
    }

    getDongtaiInfo() {
        getDongtaiInfoRequest(sessionStorage.getItem('tianyuanid'), (data) => {
            console.log(data)
            if (data.ret == '1') {

                var info = data.data;

                info.teacher_img = info.teacher_img == null || info.teacher_img == '' ? '' : FILE_URL + info.teacher_img

                if (info.content.length > 0) {
                    info.content = Base64.decode(info.content[0].content)
                }

                var list = info.img;
                for (let i = 0; i < list.length; i++) {
                    list[i].img = list[i].img == null || list[i].img == '' ? '' : FILE_URL + list[i].img
                }
                this.setState({
                    photoList: list
                });

                this.setState({
                    dongtaiInfo: info,
                    huodong_suyang: info.huodong_suyang,
                    dianzannum:info.dianzannum,
                    dianzan_status:info.dianzan_status
                });

                if (info.huifu_list == '') {
                    this.setState({
                        huifu_list: []
                    });
                } else {


                    var list = info.huifu_list;
                    for (let i = 0; i < list.length; i++) {
                        list[i].img = list[i].img == null || list[i].img == '' ? '' : FILE_URL + list[i].img
                        list[i].huifu_content = Base64.decode(list[i].huifu_content)

                    }

                    this.setState({
                        huifu_list: list
                    });

                }

            }
        });
    }

    handleImageErrored() {

        var info = this.state.dongtaiInfo;
        info.teacher_img = defaultImg;

        this.setState({
            dongtaiInfo: info
        });
    }

    handleImageErrored2(index){
        var list = this.state.huifu_list;
        list[index].img = defaultImg;

        this.setState({
            huifu_list:list
        });
    }

    handleImageErrored3(index){
        var list = this.state.photoList;
        list[index].img = errorPhoto;

        this.setState({
            photoList:list
        });
    }

    deleteDongtai() {
        var show = !this.state.showPrompt;
        this.setState({
            showPrompt: show
        });
    }

    delete() {

        deleteDongtaiRequest(sessionStorage.getItem('tianyuanid'), (data) => {
            console.log(data)
            if (data.ret == '1') {

                this.setState({
                    showPrompt: false
                });
                PubSub.publish('deleteDongtai', '');
                this.props.closeDongtaiDetailModal();
            }
        });
    }

    inputChange(content) {
        this.setState({
            inputValue: content.replace(/\s/g, '')
        });
    }

    sendComment() {
        if (this.state.inputValue == '') {
            this.showToast('请写下你的评论', 2000)
        } else {
            var content = Base64.encode(this.state.inputValue);
            sendCommentRequest(sessionStorage.getItem('tianyuanid'), content, (data) => {
                console.log(data)
                if (data.ret == '1') {
                    this.setState({
                        inputValue: ''
                    });
                    this.getDongtaiInfo();
                }
            });
        }
        //sendCommentRequest
    }

    dianzanMethod() {
        dianzanRequest(sessionStorage.getItem('tianyuanid'), (data) => {
            console.log(data)
            if (data.ret == '1') {
                this.setState({
                    dianzannum:data.data,
                    dianzan_status:'1'
                })
            } if (data.ret == '2') {
                this.setState({
                    dianzannum:data.data,
                    dianzan_status:'0'
                })
            }
        });
    }


    showToast(msg, duration) {
        duration = isNaN(duration) ? 3000 : duration;
        var m = document.createElement('div');
        m.innerHTML = msg;
        m.style.cssText = "min-width:180px; background:#000; opacity:0.6; height:auto;min-height: 30px; color:#fff; line-height:30px; text-align:center; border-radius:4px; position:fixed; top:45%; left:50%;transform: translate(-50%,-50%);padding:15px; z-index:999999;";
        document.body.appendChild(m);
        setTimeout(function () {
            var d = 0.5;
            m.style.webkitTransition = '-webkit-transform ' + d + 's ease-in, opacity ' + d + 's ease-in';
            m.style.opacity = '0';
            setTimeout(function () {
                document.body.removeChild(m)
            }, d * 1000);
        }, duration);
    }

    render() {

        return (
            <div>
                <DongtaiDetailComponent
                    info={this.state.dongtaiInfo}
                    photoList={this.state.photoList}
                    huodong_suyang={this.state.huodong_suyang}
                    handleImageErrored={this.handleImageErrored}
                    onRequestClose={this.closeDongtaiDetailModal}
                    deleteDongtai={this.deleteDongtai}
                    huifu_list={this.state.huifu_list}
                    sendComment={this.sendComment}
                    inputChange={this.inputChange}
                    inputValue={this.state.inputValue}
                    dianzanMethod={this.dianzanMethod}
                    dianzannum={this.state.dianzannum}
                    dianzan_status={this.state.dianzan_status}
                    handleImageErrored2={this.handleImageErrored2}
                    handleImageErrored3={this.handleImageErrored3}
                />
                {this.state.showPrompt ?
                    <Prompt
                        label='删除动态'
                        title='是否删除该动态？'
                        onCancel={this.deleteDongtai}
                        onOk={this.delete}
                    />
                    : null}
            </div>

        )
    }


}

DongtaiDetailContainer.propTypes = {
    // count: PropTypes.Number.isRequired,
}


const mapStateToProps = state => {
    return {
        msg: state.alert.msg,

    }
}

const mapDispatchToProps = dispatch => {
    return {
        closeDongtaiDetailModal: () => dispatch(closeDongtaiDetailModal()),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DongtaiDetailContainer);
